export enum ClientMessageType {
    ChatCreated = "ChatCreated",
    FailedText = "FailedText",
    SmartInclude = "SmartInclude",
    Reconnecting = "Reconnecting",
}
